var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"not-found"},[_c('a',{attrs:{"href":"/"}},[_vm._v("Namecard.ai")]),_c('h1',[_vm._v("Page not found")]),_c('p',[_vm._v("Let’s find the right people instead.")]),_c('a',{attrs:{"href":"/"}},[_vm._v("Back to home")]),_c('a',{attrs:{"href":_vm.introUrl}},[_vm._v("Talk to the founder")])])
}
var staticRenderFns = []

export { render, staticRenderFns }